import { Color } from "../../../../types";

export function TextColorIcon({ lineColor }: { lineColor?: Color }) {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      name="textColor"
      height="1rem"
      width="1rem"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M15.246 14H8.754l-1.6 4H5l6-15h2l6 15h-2.154l-1.6-4zm-.8-2L12 5.885 9.554 12h4.892z" />
      <path d="M3 19h18v3H3v-3z" fill={lineColor ?? "currentColor"} />
    </svg>
  );
}
